export enum ActionTypes {
  GetTimezoneOptions = 'getTimezoneOptions',
  GetTimezoneOptionsRequest = 'getTimezoneOptions.request',
  GetTimezoneOptionsSuccess = 'getTimezoneOptions.success',
  GetTimezoneOptionsFailure = 'getTimezoneOptions.failure',
}
